export default {"src":"/_next/static/media/play.4737c6dc.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};